<template>
  <TvHealth
    v-if="articles.length"
    :articles-items="articles"
  />
</template>

<script lang="ts">
  import type { PropOptions } from 'vue';
  import { ref, toRaw } from 'vue';
  import TvHealth from '~/components/TheTvHealth/TheTvHealth.vue';
  import { trimWpDomainInPlace } from '~/utils/trimWpDomain';
  import { useArticlesStore } from '~/store/articles';
  import type { Article } from '~/api/health/article';

  export default defineNuxtComponent({
    name: 'HealthTvContainer',

    components: {
      TvHealth,
    },

    props: {
      elem: {
        type: Object,
        required: true,
      } as PropOptions<TContent>,
    },

    async setup(props) {
      const articles = ref<Article[]>([]);
      const app = useNuxtApp();

      const fetchArticles = async () => {
        try {
          const { attributes } = props.elem;

          if (!attributes.type) {
            return;
          }

          const { data, error } = await useAsyncData(() => {
            if (attributes.type === 'post_tag') {
              return app.$healthApi.fetchByTag(attributes.post_tag, 'posts', { limit: 5 });
            } else {
              const categorySlug = attributes.category || attributes.subcategory;
              return app.$healthApi.fetchCategory(categorySlug, 'posts', { limit: 5 });
            }
          });

          if (error.value) {
            throw error;
          }

          if (data.value?.items) {
            trimWpDomainInPlace(data, ['items.url', 'items.categories.url']);
            articles.value = data.value.items;
          }
        } catch (e) {
          console.error(`Error in HealthTvContainer fetch: ${e}`);
          articles.value = [];
        }
      };

      await fetchArticles();

      return {
        articlesStore: useArticlesStore(),
        articles,
      };
    },

    mounted() {
      const includes = toRaw(this.articles).map((item) => item.id);

      this.articlesStore.fetchAndSetFavorites({
        post_ids: includes.join(),
        per_page: includes.length,
      });
    },
  });
</script>
